module.exports = __webpack_public_path__ + "media/typing-advanced-wrong-key.6a779bb4.mp3";